module.exports = __webpack_public_path__ + "static/media/pf.c5df4022.svg";